module.exports = __webpack_public_path__ + "img/icon_unchecked.dab7a38b.png";